import {
	Component,
	OnInit,
	ChangeDetectionStrategy,
	AfterViewInit,
	ChangeDetectorRef
} from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { Observable } from "rxjs";
import { GlobalService } from "../../services/global/global.service";
import { MEGStoreService } from "src/app/services/meg/meg-store.service";
import { DMVStoreService } from "src/app/services/dmv/dmv-store.service";
import { DMVConstants } from "../../constants/dmv.constants";
import { AppUtil } from "../../utils/app.util";
import { HeaderImageType } from "src/app/constants/header-image-type.constants";
import { USERStoreService } from "src/app/services/user/user-store.service";
import { DMVDataService } from "src/app/services/dmv/dmv-data.service";
import { USERDataService } from "src/app/services/user/user-data.service";
declare var $: any;

@Component({
	selector: "app-home",
	templateUrl: "./home.component.html",
	styleUrls: ["./home.component.css"],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class HomeComponent implements OnInit, AfterViewInit {
	constructor(
		private router: Router,
		public globalService: GlobalService,
		public megStoreService: MEGStoreService,
		public dmvStoreService: DMVStoreService,
		public dmvDataService: DMVDataService,
		public userStoreService: USERStoreService,
		public userDataService: USERDataService,
		private cd: ChangeDetectorRef
	) {}
	public errorMessage = null;
	public errorMessageForQrCode = null;
	public isloading: boolean = false;
	public optionsSelect: Array<any>;
	public defaultEntryPointWelcomeText: string;
	ngOnInit() {
		this.defaultEntryPointWelcomeText = window["defaultEntryPointWelcomeText"];
		this.globalService.cartNature = "TBD";
		this.userStoreService.loginPopupRequest = true;
		this.globalService.toggleHeaderDisplay(false);
		AppUtil.log(
			"HomeComponent ngOnInit: this.globaService.isHeaderDisplayed$ = " +
				this.globalService.getHeaderDisplayedValue()
		);

		const appType = AppUtil.getAppType();
		if (
			!(
				this.userStoreService.getUserProfile() &&
				this.userStoreService.getUserProfile().megUserGUID
			)
		) {
			this.isloading = true;
			const entryPointID =
				(window["externallink"] && window["externallink"].entryPointID) ||
				window["entryPointID"] ||
				1;
			const token =
				window["externallink"] && window["externallink"].entryPointID === "11"
					? window["externallink"].token
					: "";
			this.megStoreService.getConfigurations(appType, entryPointID, token);
		}
		this.dmvStoreService.routeFrom = null;
		this.dmvStoreService.registrationsInCart = {};
		this.dmvStoreService.addressrequired = false;
		this.dmvStoreService.paymentDetails = null;
		this.dmvStoreService.isPaymentSuccess = false;
		this.globalService.supportKioskPickup = undefined;
		this.dmvStoreService.registrationsInCart.firstIteration = true;
		this.globalService.updateHeaderImageType(HeaderImageType.DEFAULT);
		this.errorMessageForQrCode = null;
	}
	ngAfterViewInit() {
		this.megStoreService.configurationsData$.subscribe(response => {
			if (response) {
				this.isloading = false;
				if (response["status"] && response["status"] !== 200) {
					this.globalService.setQrCall(false);
					this.globalService.setDirectURLCall(false);
					this.errorMessage = DMVConstants.TIMEOUT_ERROR;
				} else {
					this.dmvStoreService.sessionGUID = response.sessionGUID;
					this.dmvStoreService.sessionID = response.sessionID;
					if (window["externallink"] && this.globalService.loginExternalLink) {
						if (window["externallink"].entryPointID === "10") {
							this.globalService.setDirectURLCall(false);
							if (response["OutcomeCode"] === 0) {
								this.router.navigate(["log-in"], {
									skipLocationChange: true
								});
							} else {
								if (
									this.globalService.isAnnouncementFlow &&
									this.dmvStoreService.agencyConfig.agencyDmvConfig.announcement
								) {
									//	this.globalService.isAnnouncementFlow = false;
									this.router.navigate(["app-announcement"], {
										skipLocationChange: true
									});
								} else {
									this.router.navigate(["county-landing"], {
										skipLocationChange: true
									});
								}
							}

							return;
						} else if (window["externallink"].entryPointID === "11") {
							if (
								response["OutcomeCode"] === 0 &&
								window["externallink"].token
							) {
								// call api
								this.accountCancellation();
							} else {
								this.globalService.setDirectURLCall(false);

								if (
									this.globalService.isAnnouncementFlow &&
									this.dmvStoreService.agencyConfig.agencyDmvConfig.announcement
								) {
									//this.globalService.isAnnouncementFlow = false;
									this.router.navigate(["app-announcement"], {
										skipLocationChange: true
									});
								} else {
									this.router.navigate(["county-landing"], {
										skipLocationChange: true
									});
								}
							}

							return;
						}
					} else {
						if (this.globalService.getDirectURLCallAfterLogin()) {
							this.globalService.setDirectURLCallAfterLogin(false);
							this.globalService.setDirectURLCall(true);
						}

						// this.globalService.setDirectURLCall(this.globalService.isCallFromloginExternalLink);

						setTimeout(() => {
							if (this.globalService.browserDetails.isDesktop) {
								$(".mdb-select").formSelect();
							}
						});

						if (window["qrDetail"] && this.globalService.getQrCall()) {
							if (window["qrDetail"].agencyID) {
								const agencies = response.megConfig.agencies.filter(item => {
									return (
										window["qrDetail"].agencyID === item.agencyID.toString()
									);
								});
								if (agencies && agencies.length > 0) {
									this.errorMessageForQrCode = null;
									this.selectCounty(window["qrDetail"].agencyID);
								} else {
									this.globalService.setQrCall(false);
									this.errorMessageForQrCode =
										response.megConfig.qrCodeErrorText;
								}
							} else {
								this.globalService.setQrCall(false);
								this.errorMessageForQrCode = response.megConfig.qrCodeErrorText;
							}
						} else if (
							this.globalService.params &&
							this.globalService.params.agencyID &&
							this.globalService.getDirectURLCall()
						) {
							const agencies = response.megConfig.agencies.filter(item => {
								return (
									this.globalService.params.agencyID ===
									item.agencyID.toString()
								);
							});
							if (agencies && agencies.length > 0) {
								this.selectCounty(this.globalService.params.agencyID);
							} else {
								this.globalService.setDirectURLCall(false);
								this.globalService.params = null;
							}
						} else {
							this.globalService.setDirectURLCall(false);
						}
					}
				}
			}

			this.cd.markForCheck();
		});

		if (
			this.globalService.countyLandingByLogIn &&
			this.userStoreService.getUserProfile().contactInfo.agencyID
		) {
			this.selectCounty(
				"" + this.userStoreService.getUserProfile().contactInfo.agencyID
			);
			this.cd.markForCheck();
		}

		// this.router.events.subscribe(val => {
		// 	if (val instanceof NavigationEnd) {

		// 	}
		// })
	}
	public accountCancellation() {
		this.isloading = true;
		this.userDataService
			.accountCancellation(
				this.dmvStoreService.sessionGUID,
				window["externallink"].token
			)
			.subscribe(response => {
				if (response && response.status) {
					this.globalService.setDirectURLCall(false);
					this.isloading = false;
					if (response.headers.get("outcomeCode") === "0") {
						// this.globalService.updateHeaderImageType(HeaderImageType.DMV);
						this.globalService.setcancellationToken(true);
						this.cd.markForCheck();
						this.dmvStoreService.cancellationTokenData = response.body;
						this.cd.markForCheck();
						this.router.navigate(["app-enrollment-cancellation"], {
							skipLocationChange: true
						});
					} else {
						if (
							this.globalService.isAnnouncementFlow &&
							this.dmvStoreService.agencyConfig.agencyDmvConfig.announcement
						) {
							//	this.globalService.isAnnouncementFlow = false;
							this.router.navigate(["app-announcement"], {
								skipLocationChange: true
							});
						} else {
							this.router.navigate(["county-landing"], {
								skipLocationChange: true
							});
						}
					}
				}
				this.cd.markForCheck();
			});
	}
	public selectCounty(selectValue: string) {
		AppUtil.log("Selected County :", selectValue);
		AppUtil.log(
			"HomeComponent selectCounty: this.globaService.isHeaderDisplayed$ = ",
			this.globalService.getHeaderDisplayedValue()
		);

		if (selectValue !== "-1") {
			if (this.dmvStoreService.selectedAgencyId !== selectValue) {
				if (this.dmvStoreService.selectedAgencyId) {
					this.globalService.params = null;
					this.globalService.setDirectURLCall(false);
				}
				this.dmvStoreService.selectedAgencyId = selectValue;
				this.isloading = true;
				this.errorMessage = null;
				this.errorMessageForQrCode = null;
				this.dmvDataService
					.getAgencyConfigResponse(
						this.dmvStoreService.selectedAgencyId,
						this.dmvStoreService.sessionID
					)
					.subscribe(
						agencyConfigData => {
							if (agencyConfigData) {
								this.isloading = false;
								this.dmvStoreService.agencyConfig = agencyConfigData;
								this.globalService.toggleHeaderDisplay(true);
								this.globalService.countyLandingByLogIn = false;

								if (
									this.globalService.isAnnouncementFlow &&
									this.dmvStoreService.agencyConfig.agencyDmvConfig.announcement
								) {
									//	this.globalService.isAnnouncementFlow = false;
									this.router.navigate(["app-announcement"], {
										skipLocationChange: true
									});
								} else {
									this.router.navigate(["county-landing"], {
										skipLocationChange: true
									});
								}
							}
						},
						error => {
							this.isloading = false;
							error.status = 408;
							this.dmvStoreService.agencyConfig = error;
							this.globalService.setQrCall(false);
							this.globalService.setDirectURLCall(false);
							this.errorMessage = DMVConstants.TIMEOUT_ERROR;
							this.cd.markForCheck();
						}
					);
			} else {
				this.globalService.toggleHeaderDisplay(true);
				this.globalService.countyLandingByLogIn = false;

				if (
					this.globalService.isAnnouncementFlow &&
					this.dmvStoreService.agencyConfig.agencyDmvConfig.announcement
				) {
					//	this.globalService.isAnnouncementFlow = false;
					this.router.navigate(["app-announcement"], {
						skipLocationChange: true
					});
				} else {
					this.router.navigate(["county-landing"], {
						skipLocationChange: true
					});
				}
			}
			//	this.dmvStoreService.findAgencyConfigById(selectValue);
		}
	}
}
